"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalState = exports.startSession = exports.getIdentifiers = exports.filterValidIdentifiers = void 0;
var config_1 = require("./config");
var auth_1 = require("./saga/auth");
function getDataInStorage(moduleName, state, options) {
    if (options === void 0) { options = {}; }
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            return __assign(__assign(__assign({}, state), JSON.parse(window.localStorage.getItem(moduleName) || '{}')), options);
        }
        catch (err) { /* empty */ }
    }
    return __assign(__assign({}, state), options);
}
exports.default = getDataInStorage;
var identifier;
var filterValidIdentifiers = function (list) {
    return list.filter(function (value) { return value > identifier - (config_1.config.session.interval + 10000); });
};
exports.filterValidIdentifiers = filterValidIdentifiers;
var getIdentifiers = function () {
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            var data = window.localStorage.getItem(config_1.config.auth.storageNameForPages);
            if (!data || data[0] !== '[') {
                return [];
            }
            return JSON.parse(data);
        }
        catch (e) {
            return [];
        }
    }
    return [];
};
exports.getIdentifiers = getIdentifiers;
exports.startSession = (function () {
    var interval;
    var update = function () {
        // console.log('startSession: > update');
        var list = (0, exports.getIdentifiers)();
        var index = list.indexOf(identifier);
        identifier = Date.now();
        if (index === -1) {
            list.push(identifier);
        }
        else {
            list.splice(index, 1, identifier);
        }
        window.localStorage.setItem(config_1.config.auth.storageNameForPages, JSON.stringify((0, exports.filterValidIdentifiers)(list)));
        return "";
    };
    return function (restart) {
        if (restart === void 0) { restart = true; }
        if (restart && interval) {
            return;
        }
        if (typeof window !== 'undefined' && window.localStorage) {
            if (interval) {
                window.clearInterval(interval);
                window.removeEventListener('beforeunload', update);
            }
            interval = setInterval(update, config_1.config.session.interval);
            window.addEventListener('beforeunload', update);
            update();
        }
    };
})();
function getLocalState(additions) {
    if (additions === void 0) { additions = {}; }
    var storageData = structuredClone(auth_1.defaultState);
    if (!config_1.config.auth.storage) {
        return storageData;
    }
    var data = getDataInStorage(config_1.config.auth.storage.name);
    if (!data.remember && !(0, exports.filterValidIdentifiers)((0, exports.getIdentifiers)()).length) {
        return storageData;
    }
    Object.assign(storageData, data);
    storageData.error = null;
    storageData.loading = false;
    Object.keys(storageData).forEach(function (key) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (storageData[key] && !Array.isArray(storageData[key]) && typeof storageData[key] === 'object') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (storageData[key].loading === true) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                storageData[key].loading = false;
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (storageData[key].error !== null) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                storageData[key].error = null;
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (storageData[key].error !== null) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                storageData[key].error = null;
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (storageData[key].response !== null) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                storageData[key].response = null;
            }
        }
    });
    if (!storageData.user) {
        storageData.authorized = false;
    }
    Object.assign(storageData, additions);
    return storageData;
}
exports.getLocalState = getLocalState;
